import productClient from '@/api/products.js'

const localStorageCartKey = 'cart'

// initial state
const state = {
  products: [],
  cart: JSON.parse(localStorage.getItem(localStorageCartKey)) || [], // { track: obj: product: pk}
  showLicenseSelectionModal: false,
  trackAddingToCart: null
}

// getters
const getters = {
  products: (state) => {
    return state.products
  },

  cart: (state) => {
    return state.cart
  },

  cartCount: (state) => {
    return state.cart.length
  },

  total: (state) => {
    if (state.cart.length === 0) {
      return 0
    }
    return state.cart.map((item) => item.product.amount).reduce((a, b) => a + b)
  },

  // Transpose cart list so it's suitable for creating an order on the API.
  cartItemsToOrder: (state) => {
    return {
      items: state.cart.map(item => {
        return { product: item.product.pk, track: item.track.pk }
      })
    }
  },

  showLicenseSelectionModal: (state) => {
    return state.showLicenseSelectionModal
  },

  trackAddingToCart: (state) => {
    return state.trackAddingToCart
  },

  currencySymbol: (state) => {
    if (state.cart.length > 0) {
      return state.cart[0].product.currency.symbol
    }
  },

  hasMixedCurrencies: (state) => {
    if (state.cart.length > 0) {
      const currencies = new Set()
      state.cart.forEach((item) => {
        currencies.add(item.product.currency.code)
      })
      return currencies.size > 1
    }
    return false
  },

  getProductFromPk: state => productsPk => {
    const products = state.products.filter(products => (products.pk === productsPk))
    if (products.length > 0) {
      return products[0]
    }
    return null
  }
}

// actions
const actions = {
  addItemToCart: (context, item) => {
    context.commit(ADD_ITEM_TO_CART, item)
  },

  removeItemFromCart: (context, item) => {
    context.commit(REMOVE_ITEM_FROM_CART, item)
  },

  clearCart: (context) => {
    context.commit(CLEAR_CART)
    context.commit(SET_TRACK_ADDING_TO_CART, null)
  },

  fetchProducts: (context) => {
    productClient.listAll()
      .then((products) => {
        context.commit(SET_PRODUCTS, products)
      })
  },

  setTrackAddingToCart: (context, track) => {
    context.commit(SET_TRACK_ADDING_TO_CART, track)
  },

  addToCart: (context, product) => {
    const item = { product, track: context.state.trackAddingToCart }
    context.commit(ADD_ITEM_TO_CART, item)
    context.commit(SET_TRACK_ADDING_TO_CART, null)
    context.commit(SET_SHOW_LICENSE_SELECTION_MODAL, false)
  },

  showLicenseSelectionModal: (context) => {
    context.commit(SET_SHOW_LICENSE_SELECTION_MODAL, true)
  },

  hideLicenseSelectionModal: (context) => {
    context.commit(SET_SHOW_LICENSE_SELECTION_MODAL, false)
  }
}

// mutations
const SET_PRODUCTS = 'SET_PRODUCTS'
const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART'
const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART'
const CLEAR_CART = 'CLEAR_CART'
const SET_TRACK_ADDING_TO_CART = 'SET_TRACK_ADDING_TO_CART'
const SET_SHOW_LICENSE_SELECTION_MODAL = 'SET_SHOW_LICENSE_SELECTION_MODAL'

const mutations = {
  [SET_PRODUCTS]: (state, products) => {
    state.products = products
  },

  [ADD_ITEM_TO_CART]: (state, item) => {
    const existing = state.cart.filter((value) => {
      return item.track.pk === value.track.pk && item.product.pk === value.product.pk
    })
    if (existing.length === 0) {
      state.cart.push(item)
      localStorage.setItem(localStorageCartKey, JSON.stringify(state.cart))
    }
  },

  [REMOVE_ITEM_FROM_CART]: (state, item) => {
    const filtered = state.cart.filter((value) => {
      return (!(item.track.pk === value.track.pk && item.product.pk === value.product.pk))
    })
    state.cart = filtered
    localStorage.setItem(localStorageCartKey, JSON.stringify(state.cart))
  },

  [CLEAR_CART]: (state) => {
    state.cart = []
    localStorage.setItem(localStorageCartKey, JSON.stringify(state.cart))
  },

  [SET_TRACK_ADDING_TO_CART]: (state, track) => {
    state.trackAddingToCart = track
  },

  [SET_SHOW_LICENSE_SELECTION_MODAL]: (state, payload) => {
    state.showLicenseSelectionModal = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
